import {
  TrackerMealConnectorApollo,
  TrackerEditMealConnectorApollo,
  useAppContext,
  TrackerRemoveMealConnectorApollo,
  formatIsoDate,
} from '@front-activerse/common-components';
import { useParams, useLocation } from 'react-router-dom';
import TrackerMealContainer from './TrackerMealContainer';

const TrackerMealPage = () => {
  const { date, dietMealId } = useParams();
  const dateString = date ? date : formatIsoDate(new Date());
  const { post } = useAppContext();

  const location = useLocation();

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  return (
    <TrackerMealConnectorApollo mealId={+dietMealId}>
      {(trackerMealData: any) => (
        <TrackerEditMealConnectorApollo post={post} originalDate={dateString}>
          {({ editMeal }: { editMeal: (input: any) => Promise<any> }) => (
            <TrackerRemoveMealConnectorApollo date={dateString}>
              {({ removeMeal }) => (
                <TrackerMealContainer
                  {...trackerMealData}
                  loading={trackerMealData.loading}
                  editMeal={editMeal}
                  //key={dietMealId}
                  key={location.key}
                  removeMeal={removeMeal}
                  date={dateString}
                />
              )}
            </TrackerRemoveMealConnectorApollo>
          )}
        </TrackerEditMealConnectorApollo>
      )}
    </TrackerMealConnectorApollo>
  );
};

export default TrackerMealPage;
